import { IListProps } from 'components/List/List';
import ListMenuItem from 'components/ListMenuItem/ListMenuItem';
import withColorQuery, { WithColorQueryProps } from 'enhancers/withColorQuery';
import withCountry, { IWithCountryProps } from 'enhancers/withCountry';
import withWindowState, { WithWindowState } from 'enhancers/withWindowState';
import * as React from 'react';
import styled from 'styled-components';

interface IProps {
  titles: string[];
  background: string;
  color: string;
  activeColor: string;
}

type Props = IProps &
  WithWindowState &
  IListProps &
  WithColorQueryProps &
  IWithCountryProps;

export const ListMenu: React.SFC<Props> = props => {
  const handleChange = (e: React.SyntheticEvent<HTMLSelectElement>) => {
    props.changeItem(parseInt(e.currentTarget.value, 10));
  };

  const background = props.window.width > 900 ? props.background : '#ffffff';

  const color = props.color;

  const activeColor = props.activeColor;
  return (
    <Container style={{ background }}>
      <div style={{ minWidth: 250 }}>
        {props.window.width > 900 ? (
          props.titles.map((title, i) => (
            <ListMenuItem
              title={title}
              myIndex={i}
              index={props.index}
              changeItem={props.changeItem}
              key={i}
              color={color}
              activeColor={activeColor}
            />
          ))
        ) : (
          <select onChange={handleChange} value={props.index}>
            {props.titles.map((title, i) => (
              <option value={i} key={i}>
                {title}
              </option>
            ))}
          </select>
        )}
      </div>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding: 60px 20px;
  width: 300px;
  @media (max-width: 900px) {
    padding: 10px;
    align-items: center;
    width: initial;
  }
`;

export default withCountry(withColorQuery(withWindowState(ListMenu)));



// WEBPACK FOOTER //
// ./src/components/ListMenu/ListMenu.tsx